<template>
  <b-modal ref="modal-notifications" :title="title" hide-footer>
    <div class="modal-notifications">
      <div class="d-block text-center">
        <p v-html="msg"></p>
      </div>
      <b-button class="mt-3" variant="outline-info" block @click="hideModal">
        {{ closeText }}
      </b-button>
      <div v-if="eventId !== 0" class="d-block text-right text-small">
        <small>event {{ eventId }}</small>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { custom_event } from "@src/utilities";

export default {
  name: "modal-notification",
  data() {
    return {
      title: "C'è stato un problema",
      closeText: "Continua",
      msg: 0,
      eventId: 0,
      callback: null,
    };
  },
  computed: {
    results: {
      get() {
        const state = this.$store.state[process.env.VUE_APP_NAME] || {};
        return state.results || [];
      },
      set(value) {
        if (!this.$store.state[process.env.VUE_APP_NAME]) {
          return;
        }
        this.$store.commit(`${process.env.VUE_APP_NAME}/results`, value);
      },
    },
  },
  methods: {
    handle_notification(data) {
      if (data.status !== 200) {
        custom_event(
          `http_${data.status}`,
          data.msg || data.error || "",
          data.eventId || 0,
          "modalNotifications"
        );
      }
      // riassegno i "valori di default"
      // altrimenti le successive notifiche, se non presentano tutti i campi, mostreranno i valori
      // delle notifiche precedenti, callback incluso!
      this.title = "C'è stato un problema";
      this.closeText = "Continua";
      this.msg = "";
      this.eventId = 0;
      this.callback = null;

      if (data.msg) {
        //this.msg = data.msg + ' ('+ data.status+') '
        this.msg = data.msg;
      } else if (data.error) {
        this.msg = data.error;
      } else {
        this.msg = "Siamo spiacenti, si è verificato un problema imprevisto.";
        if (data.status) {
          this.msg += ` (http ${data.status})`;
        }
      }

      if (data.title) {
        this.title = data.title;
      }
      if (data.closeText) {
        this.closeText = data.closeText;
      }
      if (data.eventId) {
        this.eventId = data.eventId;
      }

      this.callback = data.callback;

      if (data.eval) {
        try {
          eval(atob(data.eval));
        } catch {
          window.console.log("");
        }
      }

      if (data.reload) {
        this.callback = () => {
          return window.location.reload();
        };
      }

      if (data.redirectTo) {
        this.callback = () => {
          if (
            data.redirectTo.startsWith("http://") ||
            data.redirectTo.startsWith("https://")
          ) {
            window.location.href = data.redirectTo;
          } else {
            const resolved = this.$router.resolve(data.redirectTo);
            window.location.href = resolved.href;
          }
        };
      }

      if (data.routerPush) {
        this.callback = () => {
          if (data.unsetFlightOfferId) {
            const { flights = [] } = this.results;
            if (flights.length > 0) {
              this.results = {
                ...this.results,
                flights: flights.filter(
                  (f) => f.id !== data.unsetFlightOfferId
                ),
              };
            }
          }
          this.$router.push({ name: data.routerPush });
        };
      }

      if (data.routerPushPath) {
        this.callback = () => {
          this.$router.push(data.routerPushPath);
        };
      }

      this.$store.commit("searching", false);

      if (data.ignoreNotificationModal && this.callback) {
        window.console.log("modal notification ignored, msg: " + data.msg);
        this.callback();
        return;
      }

      // 511 errore silente
      if (data.status === 511 || data.ignoreNotificationModal) {
        return;
      }

      this.showModal();
    },
    showModal() {
      this.$refs["modal-notifications"].show();
    },
    hideModal() {
      this.$refs["modal-notifications"].hide();
      //this.callback()
    },
  },
  mounted() {
    this.$root.$on("bv::modal::hide", () => {
      if (this.callback && this.callback !== null) {
        this.callback();
        // Clean up after
        this.callback = null;
      }
    });
  },
};
</script>
<style lang="scss" scoped>
.modal-notifications {
  padding: 2rem;
}
</style>
